import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import BadgeForTable from "components/shared-components/BadgeForTable";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";

import {
  CUSTOM_DATE_FILTER_TABLE_TYPE,
  CUSTOM_SELECT_FILTER_TABLE_TYPE,
  DELAY_FILTER_TIME,
} from "constants/RemoteDataTableContanst";
import { useDownloadImport, useListImport, useListImportType } from "hooks";
import React, { useEffect, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useToasts } from "react-toast-notifications";
import { Card, CardBody, Col, Row } from "reactstrap";
import { setListImportColumn } from "store/actions";
import ImportDetail from "./ImportDetail";
import { getInitImportParams, importAuthStatus } from "./utils";

const ListImport = props => {
  const { addToast } = useToasts();

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["importManagement"]);

  const importManagement = useSelector(state => state.importManagement);
  const {
    list: { columnsVisible: importColumnsVisible },
  } = importManagement;

  /* ================================== START INIT STATE ==================================== */

  const [columnsTable, setColumnsTable] = useState([]);
  const [importTypeList, setImportTypeList] = useState([]);
  const [filterObjectType, setFilterObjectType] = useState(null);
  const [detailModal, setDetailModal] = useState(false);
  const [importId, setImportId] = useState(null);
  const [importParams, setImportParams] = useState(getInitImportParams);
  const [importList, setImportList] = useState([]);

  /* =================================== END INIT STATE ===================================== */

  /* ===================================== START HOOKS ====================================== */

  // IMPORT TYPES

  const onFetchListImportTypeSuccess = async data => {
    const result = [];
    for (const importTypes in data) {
      result.push({ label: data[importTypes], value: importTypes });
    }

    setImportTypeList(result);

    fetchListImport();
  };

  const { isLoading: isLoadingImportType, refetch: listImportType } =
    useListImportType(onFetchListImportTypeSuccess);

  // IMPORT LIST

  const fetchListImportSuccess = response => {
    const responseImportList = response?.items || [];
    const result = [];

    responseImportList.map(importItem => {
      const arrayException = [];

      if (importItem?.exception && Array.isArray(importItem?.exception)) {
        importItem.exception.map(exceptionItem => {
          const index = arrayException.findIndex(
            item => item.exception == exceptionItem.exception
          );
          if (index === -1) {
            arrayException.push({
              exception: exceptionItem.exception,
              row: exceptionItem.row !== 0 ? `Dòng ${exceptionItem.row}` : "",
            });
          } else {
            arrayException[index].row += `, ${exceptionItem.row}`;
          }
        });
      }
      result.push({ ...importItem, exception: arrayException });
    });

    setImportList(result);
  };

  const {
    isLoading: isLoadingList,
    data: importResponse,
    refetch: fetchListImport,
  } = useListImport({ params: importParams }, fetchListImportSuccess);

  useEffect(() => {
    if (importParams && importParams.run) {
      listImportType();
    }
  }, [importParams]);

  useEffect(() => {
    setImportParams(prev => ({
      ...prev,
      page: 1,
      sizePerPage: 10,
      run: true,
    }));

    initColumn();
  }, [t]);

  useEffect(() => {
    initColumn();
  }, [importTypeList]);

  /* ===================================== END HOOKS ======================================== */

  /* ================================ START FUNCTION HANDLER ================================ */

  const initColumn = () => {
    if (importColumnsVisible && Object.keys(importColumnsVisible).length > 0) {
      initColumns.forEach(item => {
        if (importColumnsVisible[item.dataField] !== undefined) {
          item.hidden = !importColumnsVisible[item.dataField];
        }
      });
    }
    setColumnsTable(initColumns);
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    if (columnFilter && Object.keys(columnFilter).length > 0) {
      // if (Object.keys(columnFilter).some(x => x.includes("object_type"))) {
      //   const keyFind = Object.keys(columnFilter).find(x =>
      //     x.includes("object_type")
      //   );
      //   columnFilter[`${keyFind}[like]`] = columnFilter[keyFind];
      //   delete columnFilter[keyFind];
      // }
    }

    setImportParams(prev => ({
      ...prev,
      sort: sortField ? sortOrder + sortField : importParams.sort,
      columnFilter: columnFilter || {},
      page: page || 1,
      sizePerPage: sizePerPage || 10,
    }));
  };

  const onSearchAllHandle = value => {
    setImportParams(prev => ({
      ...prev,
      keywords: value,
    }));
  };

  const optionShowColumnHandler = (field, value) => {
    dispatch(setListImportColumn(field, value));
    initColumn();
  };

  const selectOptionsTable = (cell = undefined, name = "", prefix = "") => {
    let options = [];
    const select = {};
    switch (name) {
      case "auth_status":
        if (prefix === "import") {
          options = importAuthStatus;
        }
        break;
      default:
        if (cell) {
          return "";
        } else {
          return select;
        }
    }

    options.forEach(item => {
      select[item.key] = t(`table.${name}.${prefix}.${item.key}`);
    });

    if (cell) {
      return select[cell];
    }

    return { ...select };
  };

  const formatOptionsTable = (cell, name = "", prefix = "") => {
    let options = [];
    switch (name) {
      case "auth_status":
        if (prefix === "import") {
          options = importAuthStatus;
        }
        break;
      default:
        return "";
    }

    return options.map(
      item =>
        item.key === cell && (
          <BadgeForTable
            key={item.key}
            badgeColor={item.badgeColor ? item.badgeColor : ""}
          >
            {selectOptionsTable(cell, name, prefix)}
          </BadgeForTable>
        )
    );
  };

  const onSuccessDownloadImport = (response, variables) => {
    const link = document.createElement("a");
    link.href = response.data;
    link.download = variables.fileName;
    link.click();
  };

  const { mutate: downloadImport } = useDownloadImport(onSuccessDownloadImport);

  const downloadFile = (id, file_name) => {
    downloadImport({
      fileId: id,
      fileName: file_name,
    });
  };

  const toggleDetailModal = (modeSet = "") => {
    setDetailModal(!detailModal);
  };

  const rowEventsHandler = {
    onDoubleClick: (e, row, rowIndex) => {
      if (
        row?.exception &&
        Array.isArray(row?.exception) &&
        row?.exception?.length > 0
      ) {
        setImportId(row.id);
        toggleDetailModal();
      }
    },
  };

  const renderException = row => {
    let messageException = "";
    if (row.exception && Array.isArray(row.exception)) {
      row.exception.map((item, index) => {
        if (index === 0) {
          messageException += `- ${item.row ? item.row + ":" : ""} ${
            item.exception
          }`;
        } else {
          messageException += `\n- ${item.row ? item.row + ":" : ""} ${
            item.exception
          }`;
        }
      });

      return (
        <div
          style={{
            cursor: "pointer",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 300,
            minWidth: 200,
          }}
        >
          {messageException}
        </div>
      );
    }
    return null;
  };

  /* ================================ END FUNCTION HANDLER ================================= */

  const listMultipleRowAction = [];

  const listRowAction = [
    {
      icon: <i className="bx bx-download font-size-18 text-primary" />,
      text: t("table.actions.download"),
      onClick: row => {
        if (row.resource) {
          downloadFile(row.resource.id, row.resource.alias_name);
        } else {
          addToast("Không tìm thấy file", {
            appearance: "error",
            autoDismiss: true,
          });
        }
      },
    },
  ];

  const initColumns = [
    {
      dataField: "object_type",
      text: t("table.object_type.import.name"),
      filter: customFilter({
        type: CUSTOM_SELECT_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => {
        return (
          <div style={{ minWidth: "200px", fontWeight: "normal" }}>
            <Select
              isClearable
              placeholder={t("common:placeholder.select")}
              options={importTypeList}
              classNamePrefix="select2-selection"
              value={filterObjectType}
              onChange={data => {
                onFilter({ data: data });
                setFilterObjectType(data);
              }}
            />
          </div>
        );
      },
      formatter: (cell, row) => {
        const objectType = importTypeList.find(
          item => String(cell) === String(item.value)
        );
        if (objectType) {
          return <span>{objectType.label}</span>;
        }
        return cell;
      },
    },
    {
      dataField: "auth_status",
      text: t("table.auth_status.import.name"),
      sort: true,
      align: "center",
      filter: selectFilter({
        placeholder: t("placeholder.select", {
          title: t("table.auth_status.import.name"),
        }),
        options: selectOptionsTable(undefined, "auth_status", "import"),
      }),
      formatter: (cell, row) => {
        if (cell && importAuthStatus.some(item => item.key === cell)) {
          return formatOptionsTable(cell, "auth_status", "import");
        } else {
          return "";
        }
      },
      allowExport: true,
    },
    {
      dataField: "exception",
      text: t("table.exception"),
      sort: false,
      allowExport: true,
      formatter: (cell, row) => {
        return renderException(row);
      },
    },
    {
      dataField: "maker_date",
      text: t("table.maker_date"),
      sort: true,
      hidden: false,
      formatter: (cell, row) => {
        if (cell) {
          return new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }).format(Number(cell) * 1000);
        } else {
          return "";
        }
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={importParams.columnFilter}
        />
      ),
    },
    {
      dataField: "maker_id",
      text: t("table.maker_id"),
      hidden: false,
      align: "center",
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        placeholder: t("placeholder.enter", {
          title: t("table.maker_id"),
        }),
      }),
      formatter: (cell, row) => {
        return row.maker && row.maker.display_name
          ? row.maker.display_name
          : cell;
      },
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{t("title.list")}</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={t("title.list") + ` (${importResponse?.totalCount || 0})`}
            breadcrumbItems={[{ name: t("title.list") }]}
          />

          <Row>
            <ImportDetail
              dataDetail={{ importId }}
              isOpenModal={detailModal}
              toggleModal={toggleDetailModal}
            />
          </Row>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  {columnsTable.length > 0 && (
                    <RemoteDataTable
                      // selectRow={selectRowCheckbox}
                      keyField="id"
                      data={importList}
                      columns={columnsTable}
                      page={importParams.page}
                      sizePerPage={importParams.sizePerPage}
                      totalSize={importResponse?.totalCount || 0}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandler}
                      rowEvents={rowEventsHandler}
                      listMultipleRowAction={listMultipleRowAction}
                      listRowAction={listRowAction}
                      loading={isLoadingImportType || isLoadingList}
                    >
                      <Link
                        to="/import-management/import"
                        className="btn btn-primary btn-label"
                      >
                        <i className="fas fa-file-upload me-2 label-icon" />
                        {t("title.import")}
                      </Link>
                    </RemoteDataTable>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListImport;
